import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\t", ";\n\tmin-height: calc(", " + ", ");\n\twidth: calc(100% + ", ");\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tdisplay: flex;\n\tmin-height: ", ";\n\tpadding-bottom: ", ";\n\tpadding-left: ", ";\n\tpadding-right: ", ";\n\tpadding-top: ", ";\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tborder-color: ", ";\n\t\t}\n\t"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\tborder-color: transparent;\n\tborder-width: ", ";\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tmin-height: ", ";\n\toutline: none;\n\tposition: relative;\n\ttext-decoration: none;\n\ttransition: background ", " linear,\n\t\tborder-color ", " linear;\n\twidth: 100%;\n\n\ta:hover > &,\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n\n\ta:focus > &,\n\t&:focus {\n\t\t", ";\n\t\tbackground-color: ", ";\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t\tcolor: ", ";\n\t}\n\n\ta:active > &,\n\t&:active {\n\t\tbackground: ", ";\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t\tcolor: ", ";\n\t}\n\n\t&.is-active,\n\t&[aria-current='page'],\n\t&[aria-selected='true'] {\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\n\t\t&:active {\n\t\t\tcolor: ", ";\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground-color: ", ";\n\t\t}\n\n\t\t&:focus {\n\t\t\tborder-color: ", ";\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n\n\t", "\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\toutline: none;\n\tpadding: 0;\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, highContrastMode, ui } from '@wp-g2/styles';
export var Menu = css(_templateObject());
export var MenuItem = css(_templateObject2(), ui.font.color.text, ui.font.size(), ui.get('menuItemBorderWidth'), ui.get('menuItemHeight'), ui.get('transitionDurationFastest'), ui.get('transitionDurationFastest'), ui.get('controlBackgroundBrightColor'), ui.zIndex('ControlFocus'), ui.get('menuItemFocusBackgroundColor'), ui.get('menuItemFocusBorderColor'), ui.get('menuItemFocusBoxShadow'), ui.get('menuItemFocusTextColor'), ui.get('menuItemActiveBackgroundColor'), ui.get('menuItemActiveBorderColor'), ui.get('menuItemActiveBoxShadow'), ui.get('menuItemActiveTextColor'), ui.get('surfaceBackgroundSubtleColor'), ui.color.text, ui.color.textInverted, ui.get('surfaceBackgroundSubtleColor'), ui.get('surfaceBackgroundSubtleColor'), ui.color.text, highContrastMode(_templateObject3(), ui.get('controlBorderColor')));
export var large = css(_templateObject4(), ui.get('menuItemHeightLarge'));
export var small = css(_templateObject5(), ui.get('menuItemHeightSmall'));
export var xSmall = css(_templateObject6(), ui.get('menuItemHeightXSmall'));
export var xxSmall = css(_templateObject7(), ui.get('menuItemHeightXXSmall'));
export var MenuHeader = css(_templateObject8(), ui.get('menuItemHeight'), ui.space(1), ui.get('controlPaddingX'), ui.get('controlPaddingX'), ui.space(1));
export var offset = css(_templateObject9(), ui.margin.x(-2), ui.margin.y(-1), ui.padding.y(2), ui.get('menuItemHeight'), ui.space(1), ui.space(4));
export var showArrow = css(_templateObject10(), ui.padding.right(1));
export var showBackArrow = css(_templateObject11(), ui.padding.left(1));